import { Delete, Filter1Rounded, Search, Sort } from "@mui/icons-material";
import {
  AppBar,
  Box,
  Tab,
  Button,
  FormControl,
  FilledInput,
  InputAdornment,
  ButtonGroup,
  Collapse,
  InputLabel,
  MenuItem,
  Select,
  Tabs,
  Paper,
  Grid,
  Badge,
  IconButton,
  Popover,
  MenuList,
  ListItemText,
  ListItemIcon,
  TextField,
} from "@mui/material";

import {
  getallaclusers,
  getalluser,
  resendemail,
  resetUsers,
  resetActualUsers,
} from "../../actions/user";


import React, { useEffect, useMemo, useState } from "react";
import { ReactComponent as Filter } from "../../assets/FilterSvg.svg";

import { ReactComponent as TableMode } from "../../assets/TableViewSvg.svg";
import { ReactComponent as TileMode } from "../../assets/TileViewSvg.svg";

import UsersTable from "./UsersTable";

import { ReactComponent as EllipseSvg } from "../../assets/EllipseSvg.svg";
import { ReactComponent as EllipseGraySvg } from "../../assets/EllipseGraySvg.svg";

import { ReactComponent as CloseSvg } from "../../assets/CloseSvg.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TabPanel from "../../components/TabPanel";
import ScopeHeader from "../../components/ScopeHeader";
import { connect } from "react-redux";
import AdminTypos from "./AdminTypos";
import AdminFaq from "./AdminFaq";
import moment from "moment";
import { useStore } from "react-redux";
import { canUserPerformAction } from "../../shared-functions/userrights";
import { getItem } from "../../utils/DataProtection";

export default connect(
  ({ isadmin, users, i18n, userProfile, aclusers, profile, profiles, profileid, lang }) => ({
    isadmin,
    users,
    i18n,
    userProfile,
    aclusers,
    profiles,
    profile,
    profileid,
    lang
  }),
  { getalluser, getallaclusers, resendemail, resetUsers, resetActualUsers }
)((props) => {
  const i18n = props.i18n;
  const aclusers = useMemo(
    () =>
      Array.isArray(props.aclusers) && props.aclusers.length
        ? props.aclusers.map((acl) => {
            return {
              ...acl,
              isCurrentUser:
                acl.user.userid === JSON.parse(getItem("userid")),
            };
          })
        : [],
    [props.aclusers]
  );
  const store = useStore().getState;
  const lang = props.lang;
  const profiles = props.profiles;


  const t = [];
  const [_users, set_users] = useState(t);

  const navigate = useNavigate();

  const users = props.users;
  const [host, setHost] = useState("");
  const [port, setPort] = useState("");
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");


  const [data, setData] = useState(users);
  const [isUsersLoading, setIsUsersLoading] = useState(true);


  const refreshList = () => {
    setIsUsersLoading(true);

    return setTimeout(() => {
      props.getalluser();
      props.getallaclusers("ACL_USERS");
    }, [2000]);
  };

  useEffect(() => {
    set_users([]);
    const refreshTimer = refreshList();

    return () => clearTimeout(refreshTimer);
  }, []);

  useEffect(() => {
    if (Array.isArray(props.users) && Array.isArray(props.aclusers)) {
      setIsUsersLoading(false);
    }
  }, [props.users, props.aclusers]);


  const location = useLocation();
  const getTabFromUrl = () => {
    const tabParam = new URLSearchParams(location.search).get("tab");
    if (tabParam == null) return null;
    const parsed = Number(tabParam);
    if (Number.isNaN(parsed)) return null;
    if (parsed >= 1) return Math.min(Math.max(parsed - 1, 0), 1);
    return Math.min(Math.max(parsed, 0), 1);
  };

  const [statusValue, setStatusValue] = useState("");

  const [appBarValue, setAppBarValue] = React.useState(
    () => getTabFromUrl() ?? (location.state ? location.state.activeTab : 0)
  );
  const [userStatus, setuserStatus] = React.useState("alle");
  const [userType, setuserType] = React.useState("");
  const [showFilter, setShowFilter] = useState(false);

  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }

  const handleAppBarChange = (
    event,
    newValue
  ) => {
    setAppBarValue(newValue);
    navigate(`/users?tab=${newValue + 1}`, { replace: true });
  };

  const [viewMode, setViewMode] = useState("table");

  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);

  let searchEnabled = searchText.length;

  const handleSearch = (e) => {
    let text = e.target.value.toLowerCase();
    setSearchText(text);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleStatusChange = (event) => {
    setuserStatus(event.target.value);
  };

  const handleChangeUserType = (event) => {
    setuserType(event.target.value);
  };

  const handleUpdateEmailConfig = async () => {
    // const paylod = {
    //   clientid: clientId,
    //   clientinfo: {
    //     autoemailconfig: {
    //       host: host,
    //       port: port,
    //       username: username,
    //       password: password,
    //     },
    //   },
    // };



    // const promises = [updateEmailConfig(paylod)]; // Ensure that promises is an array

    // if (isAuthUser === true) {
    //   try {
    //     const result = await Promise.all(promises);
    //     a11yProps(0);
    //     setAppBarValue(0);
    //   } catch (error) {
    //     console.error("Error during Promise.all:", error);
    //     // Handle the error appropriately
    //   }
    // }
  };



  useEffect(() => {
    if ((users.length && aclusers.length)) {
      const temp2 = [];

      for (const usr of users) {
        const aclUser = aclusers.length
          ? aclusers.find(
              (user) => user.user.usernodeid === usr.user.nodeid
            )
          : undefined;

        let usertype = aclUser?.user.userinfo.profileid;

        let userid = aclUser?.user.userid || "";
        let email = aclUser?.user.email || usr.user.email;

        if (usertype !== undefined) {
          temp2.push({
            ...usr,
            user: {
              ...usr.user,
              email,
            },
            userType: usertype,
            userid: userid,
            isCurrentUser: userid === JSON.parse(getItem("userid"))
          });
        }
      }

      set_users(temp2);
    }
  }, [users, aclusers]);

  useEffect(() => {
    if (users.length) {
      setData([]);
      let data = _users;

      if (searchEnabled) {
        if (searchText.length) {
          setPage(0);
          data = data.filter((row) => {
            return (
              row.user.givenname.toLowerCase().includes(searchText) ||
              row.user.surname.toLowerCase()?.includes(searchText) ||
              row.user.email.toLowerCase()?.includes(searchText)
            );
          });
        }
      }

      if (userStatus !== "alle") {
        data = data.filter((data) => {
          return data.user.active === Boolean(userStatus);
        });
      }

      if (userType !== "") {
        //console.log(data, "userTypeuserType");
        data = data.filter((data) => {
          return data.userType === userType;
        });
      }

      setData(data);
    }
  }, [searchText, userStatus, userType, _users]);

  useEffect(() => {
    if (!showFilter) {
      setStatusValue("alle");
      setuserType("");
    }
  }, [showFilter]);

  useEffect(() => {
    const tabFromUrl = getTabFromUrl();
    if (tabFromUrl != null && tabFromUrl !== appBarValue) {
      setAppBarValue(tabFromUrl);
      return;
    }
    if (tabFromUrl == null && location.state?.activeTab != null) {
      const target = Number(location.state.activeTab) + 1;
      navigate(`/users?tab=${target}`, { replace: true });
    }
  }, [location.search, location.state]);

  const getQuotaDuration = (quota) => {
    switch (quota[quota.length - 1]) {  // reading last character
      case "y":
      case "Y":
        return i18n.year;
      case "m":
      case "M":
        return i18n.month;
      case "d":
      case "D":
        return i18n.days;
      default:
        return ""
    }
  }


  const plans = JSON.parse(getItem("plans"));
  const usersPlans = JSON.parse(getItem("plans")).length ? JSON.parse(getItem("plans"))[0]?.quotas?.filter((plan) => plan.type === "USERS") : [];


  const billingInfo = JSON.parse(getItem("billinginfo"));

  const toAddInExpiry = plans?.length ? (plans[0].quotas[0]?.quota[plans[0].quotas[0]?.quota.length - 1] === "m" ? "M" : plans[0].quotas[0]?.quota[plans[0].quotas[0]?.quota.length - 1]) : "";

  const x = plans?.length ? getQuotaDuration(plans[0].quotas[0]?.quota) : "";

  const baseInfo = JSON.parse(getItem("baseinfo"));


  return (
    <div className="admin_dashboard">
      <ScopeHeader
        bgColor="#0E3F51"
        bgImage="../images/bg1.webp"
        txtColor="#FFFFFF"
        title={i18n.admin_scope_header_0}
        description={i18n.admin_scope_header_desc_0}
      />

      <Box sx={{
        bgcolor: "background.paper",

      }}>
        <AppBar
          className="appBar"
          position="static"
          variant="elevation"
          sx={{ borderTopLeftRadius: "4px", borderTopRightRadius: "4px", }}
        >
          <Tabs
            value={appBarValue}
            onChange={(e, v) => handleAppBarChange(e, v)}
            indicatorColor="secondary"
            textColor="inherit"
            aria-label="full width tabs example"
          >
            {/* <Tab className="tab" label="Ihr Abo" {...a11yProps(0)} disabled /> */}
            <Tab className="tab" label="IHR ABO" {...a11yProps(0)} style={{ padding: "0px 37px", margin: "0px", borderTopLeftRadius: "4px" }} />
            <Tab className="tab" id="btn_admin_tab_users" data-testid="btn_admin_tab_users" label="Benutzer" {...a11yProps(1)} />
          </Tabs>
        </AppBar>

        <TabPanel value={appBarValue} index={0} style={{
          marginBottom: "8%"
        }} >
          <div className="_content" style={{ padding: "2%" }}>
            <div className="abo-admin bxShadow" style={{ padding: "2%" }}>
              <div className="title">Zusammenfassung Ihres Abos</div>
              <div className="content">
                <div className="col1">
                  <AdminTypos primary={"Derzeitiges Abo"} secondary={plans.length && plans[0].name} style={{ borderBottom: "1px solid lightgray" }} />
                  <AdminTypos primary={"Laufzeit"} secondary={plans.length && plans[0].quotas ? ("" + plans[0].quotas[0]?.quota.match(/-?\d+\.?\d*/)[0] + " " + getQuotaDuration(plans[0].quotas[0]?.quota)) : ""} style={{ borderBottom: "1px solid lightgray" }} />
                  <AdminTypos primary={"Abonniert am"} secondary={plans.length && plans[0].quotas ? moment(plans.length && plans[0].quotas[0]?.startingfrom).format("DD.MM.YYYY") : ""} style={{ borderBottom: "1px solid lightgray" }} />
                  {
                    plans.length && plans[0].quotas ?
                      <AdminTypos primary={"Autom. Verlängerung"} secondary={ moment(plans.length && plans[0].quotas[0]?.startingfrom).add(plans.length && plans[0].quotas[0]?.quota.match(/-?\d+\.?\d*/)[0], toAddInExpiry).format("DD.MM.YYYY")} style={{ borderBottom: "1px solid lightgray" }} />
                      : ""
                  }
                  <AdminTypos primary={"Kündigungsfrist"} secondary={plans.length && plans[0].quotas ? (plans.length && plans[0].quotas[0]?.noticeperiod && plans.length && plans[0].quotas[0]?.noticeperiod.replace("m", " Monat") + " zur Verlängerung") : ""} style={{ borderBottom: "1px solid lightgray" }} />

                </div>
                <div className="col2">
                  <AdminTypos primary={"Name Ihrer Organisation"} secondary={baseInfo ? baseInfo.name : ""} style={{ borderBottom: "1px solid lightgray" }} />

                  <AdminTypos primary={"User-Limit"} secondary={usersPlans[0]?.quota ? (usersPlans[0]?.quota + " (derzeit " + props.users.length + " genutzt)") : ""} style={{ borderBottom: "1px solid lightgray" }} />
                  <AdminTypos primary={"Subscription"} secondary={billingInfo.subscriptionid ? billingInfo.subscriptionid : ""} style={{ borderBottom: "1px solid lightgray" }} />

                </div>
              </div>
            </div>

            <div className="abo-admin bxShadow" style={{ padding: "2%", margin: "3% 0%" }}>
              <div className="title">Rechnungsstellung</div>
              <div className=" box-2">
                <div className="title1">Rechnungsstellung</div>
                <pre className="title2">
                  {billingInfo.billingname} {"\n"}
                  {billingInfo.billingstreet} {billingInfo.billingstreetnumber}  {"\n"}
                  {billingInfo.billingzipcode} {billingInfo.billingcity}  {"\n"}
                  {billingInfo.billingcountry}
                </pre>
                <div className="admin-typos-2">
                  <AdminTypos primary={"Rechnungsversand"} secondary={"Elektronisch (per E-Mail)"} style={{ borderBottom: "1px solid lightgray" }} />
                  <AdminTypos primary={"Versand an"} secondary={`${billingInfo?.billingbillingemail ? billingInfo?.billingbillingemail : ""}`} />
                </div>
              </div>
            </div>


            <div className="admin-smallDesc">Für Änderungen am Abo oder der Rechnungsstellung kontaktieren Sie bitte den Kundenservice.</div>

            <div className="admin-footer">
              <div className="faq">
                <div className="_title">Häufige Fragen und Antworten</div>
                <div className="_answer"><AdminFaq data={[{
                  question: "Ich benötige mehr User als mein Limit zulässt. Wie kann ich weitere hinzubuchen?",
                  answer: ` <div>Bitte senden Sie eine Email an <a href="mailto:247uptime@247factorynet.com">247uptime@247factorynet.com</a> mit der Angabe Ihrer Subscription ID und der gewünchen Anzahl Ihrer User. </div> `
                },
                { question: "Wie kann ich weitere Administratoren erstellen?", answer: "Erstellen Sie einfach einen neuen User und geben Sie diesem die Rolle Admin." },
                { question: "An wen kann ich mich bei technischen Fragen wenden?", answer: "Bitte wenden Sie sich mit allen Anliegen an support@247factorynet.com" },
                { question: "Wie verwalte ich meinen eigenen Benutzeraccount?", answer: "Bitte wählen Sie Profil & Einstellungen neben Ihrem Namen rechts oben im Bildschirm." },
                { question: "Wie kann ich mein 247uptime Abo kündigen?", answer: `<div>Wenn Sie Ihr Abo kündigen möchten, teilen Sie uns dies bitte per Mail an <a href="mailto:247uptime@247factorynet.com">247uptime@247factorynet.com</a> unter Angabe Ihrer Subscription ID mit.</div> ` }]} /></div>
              </div>

              <div className="admin-customer">
                <div className="_title">Kundenservice</div>
                <div className="avatarWrapper">
                  <div className="avatar"><div className="bxShadow" /></div>
                  <div className="avatarContent">
                    <div className="_name">Konstantin</div>
                    {/* <div className="_phone"> <a href="tel:+49 (0)8158 9239817">+49 (0)8158 9239817</a></div> */}
                    <div className="_email"> <a href="mailto:support@247factorynet.com">support@247factorynet.com</a></div>
                    <div className="_timing">Mo.–Fr. 08–16 Uhr</div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </TabPanel>

        <TabPanel value={appBarValue} index={1} style={{
          marginBottom: "8%"
        }}>
          <div className="_content" style={{ marginBottom: "23%" }}>
            <div className="header">
              <div
                className="_title"
                style={{ display: "flex", alignItems: "center", gap: "20px" }}
              >
                <div> <b>Benutzer</b> ({data.length})</div>

                {canUserPerformAction(
                  props.profile?.features?.user,
                  "create"
                ) && (

                    <div className="_button">
                      <Link to={"/add-user"} state={{ padeType: "add" }}>
                        <Button variant="contained" id="btn_users_add" data-testid="btn_users_add">
                          + NEU
                        </Button>
                      </Link>
                    </div>)}
              </div>

              <div
                style={{
                  marginLeft: "auto",
                  display: "flex",
                  alignItems: "center",
                  gap: "24px",
                }}
              >
                <div className="_users_list" style={{ width: "257px" }}>
                  <FormControl fullWidth variant="standard">
                    <TextField
                      variant="standard"
                      placeholder={i18n?.admin_search_placeholder}
                      value={searchText}
                      onChange={handleSearch}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end" sx={{ ml: 1 }}>
                            <Search sx={{ color: "rgba(0,0,0,0.54)" }} />
                          </InputAdornment>
                        ),
                      }}
                      inputProps={{
                        "aria-label": "weight",
                        "data-testid": "txtf_users_search",
                        id: "txtf_users_search",
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          fontSize: "16px",
                          color: "rgba(0,0,0,0.87)",
                        },
                      }}
                    />
                  </FormControl>
                </div>
                <div className="_filterBtn">
                  <Button
                    variant={"outlined"}
                    startIcon={
                      showFilter ? (
                        <CloseSvg />
                      ) : (
                        <Filter />
                      )
                    }
                    onClick={() => {
                      setShowFilter(!showFilter);
                    }}
                    data-testid="btn_users_filter_view"
                    sx={{
                      minWidth: "88px",
                      height: "36px",
                      px: "8px",
                      border: "1px solid rgba(0,0,0,0.12)",
                      color: "#0E3F51",
                      "&:hover": { border: "1px solid rgba(0,0,0,0.24)" },
                    }}
                  >
                    FILTER
                  </Button>
                </div>
                <div className="_buttonGroup">
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Basic button group"
                    sx={{ height: "36px", boxShadow: "none" }}
                  >
                    <Button
                      sx={{
                        width: "36px",
                        minWidth: "36px",
                        padding: 0,
                        borderColor: "rgba(0,0,0,0.12)",
                        backgroundColor:
                          viewMode === "tile" ? "#0E3F51" : "transparent",
                        "&:hover": {
                          backgroundColor:
                            viewMode === "tile"
                              ? "#0E3F51"
                              : "rgba(14,63,81,0.06)",
                        },

                        ".MuiButton-startIcon" : {
                          margin: "0 !important"
                        },
                        opacity : 0.5
                      }}
                      startIcon={
                        <TileMode
                          color={viewMode === "tile" ? "#FFFFFF" : "#0C266E"}
                        />
                      }
                      onClick={() => setViewMode("tile")}
                      variant={viewMode === "tile" ? "contained" : "outlined"}
                      disabled

                    ></Button>
                    <Button
                      sx={{
                        width: "36px",
                        minWidth: "36px",
                        padding: 0,
                        borderColor: "rgba(0,0,0,0.12)",
                        backgroundColor:
                          viewMode === "table" ? "#0E3F51" : "transparent",
                        "&:hover": {
                          backgroundColor:
                            viewMode === "table"
                              ? "#0E3F51"
                              : "rgba(14,63,81,0.06)",
                        },
                        ".MuiButton-startIcon" : {
                          margin: "0 !important"
                        }
                      }}
                      startIcon={
                        <TableMode
                          color={viewMode === "table" ? "#FFFFFF" : "#0C266E"}
                        />
                      }
                      onClick={() => setViewMode("table")}
                      variant={viewMode === "table" ? "contained" : "outlined"}
                    ></Button>
                  </ButtonGroup>
                </div>
              </div>
            </div>

            <Box
              sx={{ height: "auto", backgroundColor: "#2121210D" }}
              style={{ marginTop: showFilter ? "3%" : "0%" }}
            >
              <Box
                sx={{
                  "& > :not(style)": {
                    display: "flex",
                    justifyContent: "space-around",
                    height: "auto",
                    width: "100%",
                  },
                }}
              >
                <div>
                  <Collapse in={showFilter} sx={{ width: "100%" }}>
                    <div className="history-filters" style={{ backgroundColor: "transparent"}}>
                      <div className="row1">
                        <div className="child">
                          <FormControl
                            variant="standard"
                            sx={{ margin: 0 }}
                            fullWidth
                          >
                            <InputLabel id={"filter_type"}>
                              {"User-Account-Status"}
                            </InputLabel>
                            <Select
                              labelId={"filter_type"}
                              id={"filter_type"}
                              data-testid="drpdwn_users_status_filter"
                              label="Filter"
                              value={userStatus}
                              onChange={handleStatusChange}
                            >
                              <MenuItem value="alle" data-testid="drpdwn_users_status_filter_li">
                                <em>alle</em>
                              </MenuItem>
                              {[
                                {
                                  name: "Aktive",
                                  value: 1,
                                },
                                {
                                  name: "In-Aktive",
                                  value: 0,
                                },
                              ].map((noti, key) => {
                                return (
                                  <MenuItem value={noti.value} key={key} data-testid="drpdwn_users_status_filter_li">
                                    {noti.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </div>

                        <div className="child">
                          <FormControl
                            variant="standard"
                            sx={{ margin: 0 }}
                            fullWidth
                          >
                            <InputLabel id={"filter_status"}>
                              {"Benutzertyps"}
                            </InputLabel>
                            <Select
                              id={"filter_status"}
                              label="Filter"
                              value={userType}
                              onChange={handleChangeUserType}
                              data-testid="drpdwn_users_type_filter"
                            >
                              <MenuItem value="">
                                <em>alle</em>
                              </MenuItem>
                              {profiles &&
                                profiles?.map((profile) => {
                                  return (
                                    <MenuItem value={profile.id}>
                                      {profile?.name.de}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              </Box>
            </Box>

            <UsersTable
              data={data}
              isLoading={isUsersLoading}
              handlePageChange={handleChangePage}
              searchText={searchText}
              page={page}
              refreshList={refreshList}
              setPage={setPage}
              viewMode={viewMode}
              profiles={props.profiles}
              profile={props.profile}
            />
          </div>
        </TabPanel>
      </Box>
    </div>
  );
})
